const ctrl = [
    '$rootScope',
    '$location',
    'ProductsFactory',
];

class ProductCtrl {
    constructor(
        $rootScope,
        $location,
        ProductsFactory
    ) {
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.ProductsFactory = ProductsFactory;

        this.classes = [];

        this.selections = {};

        this.os = {};

        this.humaizedClasses = {
            agent: 'Snare Enterprise Agent',
            epilog: 'Snare Enterprise Epilog',
            mssql: 'Snare Enterprise MSSQL',
            sam: 'Snare Agent Manager',
            server: 'Snare Server',
            msi: 'MSI',
            adm: 'Microsoft ADM / ADMX Template',
            reflector: 'Snare Reflector',
            wec: 'Snare Enterprise Agent with Windows Event Collection',
        };

        this.crumbs = [
            {
                text: 'Products & Editions',
            },
        ];

        this.setup();

        this.$rootScope.$on('ProductsFetched', () => this.setup());
    }

    _setClasses() {
        this.classes = this.ProductsFactory.getClasses().map((item) => {
            return {
                raw: item,
                humanized: this.humaizedClasses[item],
            };
        });

        const defaultOrderClass = ['agent', 'epilog', 'mssql', 'sam', 'adm', 'server', 'reflector'];

        this.classes = this._removeAndPrependClass(this.classes, defaultOrderClass);
    }

    _removeAndPrependClass(arr, elements) {
        const removalArr = [];
        elements.forEach(function(value) {
            arr.forEach(function(obj, key) {
                if(obj.raw === value) {
                    arr.splice(key, 1);
                    removalArr.push(obj);
                }
            });
        });

        return removalArr.concat(arr);
    }

    _setEditions() {
        this.ProductsFactory.getProducts().map((item) => {
            let osName = item.os;

            if(!osName) {
                osName = 'other';
            }

            if(!this.os[item.class]) {
                this.os[item.class] = {};
            }

            if(!this.os[item.class][osName]) {
                this.os[item.class][osName] = [];
            }

            this.os[item.class][osName].push(item);
        });
    }

    _resetEditions() {
        this.editions = {};
    }

    getEditions() {
        if(!this.os[this.getSelection('product')]) {
            return;
        }
        const selected = this.getSelection('os');
        return this.os[this.getSelection('product')][selected];
    }

    getProductOs() {
        if(!this.os) {
            return;
        }
        return this.os[this.getSelection('product')];
    }

    select(key, value) {
        this.selections[key] = value;
        this._additionSelectionActions(key);
    }

    _additionSelectionActions(key) {
        if(key === 'product') {
            this._selectIfOnlyOsOtherwiseDelete();
        }

        if(key === 'os') {
            this._selectIfOnlyEditionOtherwiseDelete();
        }
    }

    _selectIfOnlyOsOtherwiseDelete() {
        const oss = this.getProductOs();

        if(Object.keys(oss).length === 1) {
            this.select('os', Object.keys(this.os[this.getSelection('product')])[0]);
        } else {
            delete this.selections.os;
            delete this.selections.edition;
        }
    }

    _selectIfOnlyEditionOtherwiseDelete() {
        const editions = this.getEditions();
        if(editions.length === 1) {
            this.select('edition', this.os[this.getSelection('product')][this.getSelection('os')][0].static_name);
        } else {
            delete this.selections.edition;
        }
    }

    getSelection(key) {
        return this.selections[key];
    }

    getStepNo() {
        return this.hasOS() ? 3 : 2;
    }

    isSelected(key, value) {
        return this.getSelection(key) === value;
    }

    hasSelection(key) {
        return !!this.getSelection(key);
    }

    hasOS() {
        if(this.getSelection('product')) {
            const keys = Object.keys(this.getProductOs());
            if(keys.length > 0 && keys[0] === 'other') {
                return !this.getSelection('product');
            }
        }

        return !!this.getSelection('product');
    }

    hasEdition() {
        return !!this.getEditions();
    }

    setup() {
        this._resetEditions();
        this._setClasses();
        this._setEditions();
    }

    view() {
        this.$location.path(this.getSelection('edition'));
    }

    selectedClass(key, value) {
        return this.isSelected(key, value) ? 'active' : '';
    }

    stepTwoStatusClass() {
        return this.hasSelection('product') ? '' : 'dull';
    }

    submitStatusClass() {
        return this.hasSelection('edition') ? '' : 'disabled';
    }
}

ctrl.push(ProductCtrl);

export default ctrl;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/controllers/ProductListCtrl.js